<template>
  <div class="legal-contenedor">
    <div class="legal-card">
      <img class="logo" src="@/assets/imagenes/logotipo.png" alt="Domédica" />
      <h1 class="titulo">Aviso de Privacidad</h1>
      <pre class="legal-texto-plano">{{ texto }}</pre>
      <button class="btn-volver" @click="$router.back()">
        <span class="material-icons">arrow_back</span>
        Volver
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginaPrivacidad',
  data() {
    return {
      texto: 'Cargando…',
    };
  },
  async created() {
    try {
      const respuesta = await fetch('/privacidad.txt');
      this.texto = respuesta.ok ? await respuesta.text() : 'No se pudo cargar el aviso de privacidad.';
    } catch {
      this.texto = 'No se pudo cargar el aviso de privacidad.';
    }
  },
};
</script>

<style scoped>
.legal-contenedor {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 40px 16px;
  background: var(--brand-beige);
}

.legal-card {
  width: min(820px, 100%);
  background: var(--white);
  border-radius: 18px;
  padding: 36px clamp(20px, 4vw, 44px);
  box-shadow: 0 8px 25px rgba(19, 62, 104, 0.12);
}

.logo {
  display: block;
  width: 140px;
  margin: 0 auto 20px;
}

.titulo {
  color: var(--brand-primary);
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 28px;
}

.legal-texto-plano {
  white-space: pre-wrap;
  font-family: inherit;
  color: var(--brand-secondary);
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.btn-volver {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 28px auto 0;
  padding: 12px 24px;
  background: var(--brand-accent-sage);
  color: var(--white);
  border: none;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-volver:hover { background: var(--brand-accent-navy); }
</style>
